/**
 * Qué filas muestra la tabla del Catálogo en una página.
 *
 * Son dos fuentes que no se pueden paginar juntas: los publicados salen del índice, que
 * pagina, y los no publicados (borradores y versiones en revisión) salen enteros de SQL.
 *
 * - **Vista mezclada:** los no publicados van enteros en la página 1, primero los que están
 *   en revisión, y la paginación es la de los publicados.
 * - **Vista de sólo no publicados** (filtro *En revisión* o *Borrador*): no hay publicados,
 *   así que los no publicados **se paginan en memoria** (xcons-docs#632). Antes iban todos en
 *   la 1 y desde la 2 la tabla llegaba vacía: con 2.962 pendientes, la única forma de
 *   aprobar en tandas era recargar la página 1, y eso superponía las masivas.
 */
export function filasDeLaPagina<
  D extends { state?: string | null },
  H,
>(opciones: {
  drafts: D[];
  hits: H[];
  page: number;
  pageSize: number;
  soloSinPublicar: boolean;
}): Array<D | H> {
  const { drafts, hits, page, pageSize, soloSinPublicar } = opciones;
  if (soloSinPublicar) {
    return drafts.slice((page - 1) * pageSize, page * pageSize);
  }
  if (page !== 1) return hits;
  const enRevision = drafts.filter((d) => d.state === "review");
  const borradores = drafts.filter((d) => d.state !== "review");
  return [...enRevision, ...borradores, ...hits];
}

/** La vista de sólo no publicados: el filtro de estado en *En revisión* o *Borrador*. */
export const esVistaSinPublicar = (estado: string | undefined | null) =>
  estado === "draft" || estado === "review";
